export default "__VITE_PUBLIC_ASSET__7b1e2471__"